<template>
  <v-app id="inspire" class="background-svg" :style="backgroundStyle">
    <v-main>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs11 sm6 md4>
            <v-card class="elevation-12 pb-10 px-4 pt-5" min-width="400">
              <v-card-title
                class="text-center d-flex flex-column justify-center"
              >
                <div class="justify-center">
                  <v-img
                    :src="API_BASE_URL + '/web_front/icon_logo.svg'"
                    class="logo-svg"
                  ></v-img>
                </div>
                <br />
                <div>
                  <span>Login</span>
                </div>
              </v-card-title>
              <v-card-text>
                <v-form>
                  <v-col cols="12" class="d-flex">
                  <country-code-select
                    v-model="selectedCountryCode"
                    @onSelect="onSelect" 
                    class="custom-country-code-select"

                  ></country-code-select>
                  <v-text-field
                    v-model="user.mobileNo"
                    name="mobileNo"
                    label="Mobile No"
                    outlined
                    dense
                    type="text"
                    v-validate="'required|integer|min:6|max:15'"
                    :error="
                      errors.first('mobileNo') != null ||
                        serverSideErrors.mobileNo != null
                    "
                    :error-messages="
                      errors.first('mobileNo') || serverSideErrors.mobileNo
                    "
                  ></v-text-field>
                  </v-col>
                </v-form>
              </v-card-text>
              <v-row>
                <v-col cols="7">
                  <!-- <v-checkbox
                    v-model="remember"
                    label="Remember Me"
                    color="primary"
                    value="primary"
                    hide-details
                    class="ma-0 ml-3"
                  ></v-checkbox> -->
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="px-6">
                  <v-btn
                    block
                    color="primary"
                    @click="login"
                    :loading="loading"
                  >
                    Send OTP
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-flex>
          <Alert />
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Alert from "../../Alert.vue";
import "@/assets/style.css";
import { mapMutations } from "vuex";

export default {
  components: {
    Alert,
  },
  data() {
    return {
      user: {
        mobileNo: "",
        country_code:""
      },
      selectedCountryCode: "",
      remember: false,
      loading: false,
      serverSideErrors: {},
    };
  },
  computed: {
    backgroundStyle() {
      return {
        backgroundImage: `url(${process.env.VUE_APP_API_URL}/web_front/bulding.svg)`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center' ,
        height: '100vh' ,
      };
    }
  },
  methods: {
    onSelect(event) {
      this.user.country_code = '+' + event.dialCode;
    },
    ...mapMutations("alert", ["setAlert"]),
    login() {
      let _self = this;

      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.remember) {
            localStorage.setItem("mobileNo", this.user.mobileNo);
          }

          _self.loading = true;

          _self.$axios
            .post("/societyadmin/sendOtp", this.user)
            .then((response) => {
              let data = response.data;
              _self.loading = false;

              if (data.status) {
                this.setAlert({
                  showAlert: true,
                  variant: "green accent-4",
                  timeout: "2000",
                  message: data.message,
                });

                _self.$router.push({
                  path: "/societyadmin/verifyOtp/" + _self.user.mobileNo,
                });
              } else {
                if (data.errors) {
                  _self.serverSideErrors = {};

                  for (let i = 0; i < data.errors.length; i++) {
                    _self.serverSideErrors[data.errors[i].field] =
                      data.errors[i].message;
                  }
                } else {
                  this.setAlert({
                    showAlert: true,
                    variant: "red accent-3",
                    timeout: "2000",
                    message: data.message,
                  });
                }
              }
            });
          return;
        }
      });
    },
  },
  mounted() {
    let mobileNo = localStorage.getItem("mobileNo");
    if (mobileNo) {
      this.user.mobileNo = mobileNo;
    }
  },
};
</script>

<style scoped>
.logo-svg {
  width: 150px !important;
}
.custom-country-code-select {
  width: 59px;
    height: 40px;
    margin-top: 10px
}
</style>
